import type { TomeVibe, TomeVibeName } from '../primitives/tome';

export interface PlayerWindowConfig {
  title?: string;
  eyebrow?: string;
  size?: { width: number; height: number };
  presentation?: 'window' | 'tome';
  vibe?: TomeVibeName | TomeVibe;
  scrollable?: boolean;
}

/** Comfortable first-open sizes. Saved geometry and window IDs remain authoritative. */
export const PLAYER_WINDOW_PRESENTATION: Record<string, PlayerWindowConfig> = {
  crafting: {
    title: 'Crafting',
    eyebrow: 'Workshop',
    size: { width: 680, height: 600 },
    presentation: 'tome',
    scrollable: false,
  },
  inventory: {
    title: 'Inventory',
    eyebrow: 'Possessions',
    size: { width: 680, height: 600 },
    presentation: 'tome',
    scrollable: false,
  },
  spells: {
    title: 'Spellbook',
    eyebrow: 'Grimoire',
    size: { width: 680, height: 580 },
    presentation: 'tome',
    scrollable: false,
  },
  equipment: {
    title: 'Character',
    eyebrow: 'Hero',
    size: { width: 680, height: 600 },
    presentation: 'tome',
    scrollable: false,
  },
  talents: {
    title: 'Talents',
    eyebrow: 'Specialization',
    size: { width: 760, height: 620 },
    presentation: 'tome',
    scrollable: false,
  },
  quests: {
    title: 'Quest journal',
    eyebrow: 'Your journey',
    size: { width: 760, height: 620 },
    presentation: 'tome',
    scrollable: false,
  },
  worldMap: {
    title: 'World Atlas',
    eyebrow: 'Cartography',
    size: { width: 1040, height: 700 },
    presentation: 'tome',
    scrollable: false,
  },
  leaderboard: {
    title: 'Leaderboard',
    eyebrow: 'Rolls of the realm',
    size: { width: 520, height: 560 },
    presentation: 'tome',
    scrollable: false,
  },
  inspect: {
    title: 'Inspect',
    eyebrow: 'Adventurer’s sheet',
    size: { width: 440, height: 560 },
    presentation: 'tome',
  },
  chestLoot: { title: 'Loot', eyebrow: 'Chest', size: { width: 400, height: 380 }, presentation: 'tome' },
  trade: { size: { width: 680, height: 620 } },
  party: {
    title: 'Party',
    eyebrow: 'Adventure together',
    size: { width: 480, height: 560 },
    presentation: 'tome',
  },
  keyBindings: {
    title: 'Key Bindings',
    eyebrow: 'Controls & Input',
    size: { width: 980, height: 640 },
    presentation: 'tome',
    scrollable: false,
  },
  settings: {
    title: 'Settings',
    eyebrow: 'Make it yours',
    size: { width: 760, height: 620 },
    presentation: 'tome',
    scrollable: false,
  },
};
